import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    // Si no hay token, redirige al login
    return <Navigate to="/login" />;
  }

  try {
    const decoded = jwtDecode(token);

    // Aquí se puede agregar lógica para verificar si el token ha expirado
    // Por ejemplo, si decoded.exp * 1000 < Date.now() ...

    // Si se especificaron roles permitidos, comprobamos si el rol del usuario está incluido
    if (allowedRoles.length > 0 && !allowedRoles.includes(decoded.role)) {
      return <Navigate to="/unauthorized" />;
    }
  } catch (error) {
    console.error("Error al decodificar el token:", error);
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
